import React from 'react';
import styles from './Hero.module.css';

const Hero = () => {

  const companies = [
    { name: '4tuna', duration: 'Cliente há 2 anos', isLongTerm: true },
    { name: 'Mami Wata', duration: 'Cliente há 1 ano', isLongTerm: true },
    { name: 'Lidere Estágio', duration: 'Cliente há 7 meses', isLongTerm: false },
    { name: 'Dou.Me', duration: 'Cliente há 6 meses', isLongTerm: false },
    { name: 'Irack Motos', duration: 'Cliente há 1 ano', isLongTerm: true },
    { name: 'Toco Me Voy', duration: 'Cliente há 8 meses', isLongTerm: false },
    { name: 'L1V3', duration: 'Cliente há 4 meses', isLongTerm: false }
  ];

  return (
    <section className={styles.hero}>
      <div className={styles.heroContent}>
        <h1 className={styles.title}>
          Uma solução para cada momento do seu negócio
        </h1>
        <p className={styles.subtitle}>
          Desenvolvemos soluções digitais inovadoras que impulsionam seu negócio para o próximo nível. 
          Sites, e-commerces e aplicativos personalizados com tecnologia de ponta.
        </p>

        <div className={styles.ctaContainer}>
          <a
            href="https://wa.me/5521974561726?text=Olá! Quero saber mais sobre os serviços da BeDev"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.whatsappButton}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.149-.67.149-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414-.074-.123-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
            </svg>
            <span>Fale conosco no WhatsApp</span>
          </a>
        </div>

        <div className={styles.companiesSection}>
          <h3 className={styles.companiesTitle}>Empresas que confiam em nós</h3>
          <div className={styles.companiesContainer}>
            <div className={styles.companiesTrack}>
              {companies.map((company, index) => (
                <div key={index} className={`${styles.companyCard} ${company.isLongTerm ? styles.longTerm : ''}`}>
                  <div className={styles.companyLogo}>{company.name}</div>
                  <div className={styles.companyDuration}>{company.duration}</div>
                </div>
              ))}
              {companies.map((company, index) => (
                <div key={`duplicate-${index}`} className={`${styles.companyCard} ${company.isLongTerm ? styles.longTerm : ''}`}>
                  <div className={styles.companyLogo}>{company.name}</div>
                  <div className={styles.companyDuration}>{company.duration}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className={styles.heroBackground}></div>
    </section>
  );
};

export default Hero;